export default __webpack_public_path__ + "static/media/splashPage.21985792.jpg";